import logo from '../../assets/images/logo-e2n.png';

export function Header() {
  return (
    <div className="w-full flex justify-center p-8">
      <img src={logo} className="w-24" />
    </div>
  );
}
